/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type CardDtoProvider = typeof CardDtoProvider[keyof typeof CardDtoProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardDtoProvider = {
  BATT_MOBILITY: 'BATT_MOBILITY',
  TAP_ELECTRIC: 'TAP_ELECTRIC',
  TOTAL_ENERGIES: 'TOTAL_ENERGIES',
  OPTIMILE: 'OPTIMILE',
  DUCOOP: 'DUCOOP',
  BLUE_CORNER: 'BLUE_CORNER',
  CAPS: 'CAPS',
  STROOHM: 'STROOHM',
  BLINK: 'BLINK',
  ELECTRIC_BY_DIETEREN: 'ELECTRIC_BY_DIETEREN',
  LUMINUS: 'LUMINUS',
  ENERGY_DRIVE: 'ENERGY_DRIVE',
  Q8_ELECTRIC: 'Q8_ELECTRIC',
  DATS24: 'DATS24',
  FREE2MOVE: 'FREE2MOVE',
  SHELL_RECHARGE: 'SHELL_RECHARGE',
  ENERGY_VISION: 'ENERGY_VISION',
  CHARGEMAP: 'CHARGEMAP',
  ENECO_EMOBILITY: 'ENECO_EMOBILITY',
  ENGIE: 'ENGIE',
  PLUGSURFING: 'PLUGSURFING',
  MERCEDES_ME: 'MERCEDES_ME',
  FASTNED: 'FASTNED',
} as const;
